import { BaseData, BaseDataContent } from 'types/base.type'
import { FamiliarReferenceType } from 'types/familiar-reference.type'
import { PageableProps } from 'types/pageable.type'
import client from './client'

class FamiliarReferenceService {
  getAll = async (
    teenagerId: string,
    pageable: PageableProps,
  ): Promise<BaseDataContent<FamiliarReferenceType[]>> => {
    const url = `/adolescente/${teenagerId}/referencia-familiar`

    const params = { ...pageable }

    return await client
      .get<BaseDataContent<FamiliarReferenceType[]>>(url, params)
      .then((res) => res)
  }

  create = async (teenagerId: string, body?: FamiliarReferenceType): Promise<BaseData<string>> => {
    const url = `/adolescente/${teenagerId}/referencia-familiar`

    return await client.post<BaseData<string>>(url, body).then((res) => res)
  }

  update = async (id: number, body?: FamiliarReferenceType): Promise<BaseData<string>> => {
    const url = `/referencia-familiar/${id}`

    return await client.put<BaseData<string>>(url, body).then((res) => res)
  }

  delete = async (id?: number): Promise<BaseData<string>> => {
    const url = `/referencia-familiar/${id}`

    return await client.delete<BaseData<string>>(url).then((res) => res)
  }
}

export default new FamiliarReferenceService()
